import React, { useContext, useState, useEffect } from "react";
import {
  Stack,
  Box,
  Grid2 as Grid,
  TextField,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Tooltip,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";
import moment from "moment";
//Icons
import { BiMinusCircle } from "react-icons/bi";

//Srcs
import "../../Style/dialogStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import DatePickerForDialog from "../Include/SelecteDatePicker/DatePickerForDialog";
import { CREATE_ATTENDANCE_BY_DAY } from "../../Schema/Attendance";

export default function GenerateAttendanceByDay({
  open,
  handleClose,
  setRefetch,
  classId,
}) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);

  //======================== Create User =========================
  const [createClassAttenceByDay] = useMutation(CREATE_ATTENDANCE_BY_DAY, {
    onCompleted: ({ createClassAttenceByDay }) => {
      // console.log("createClassAttenceByDay::", createClassAttenceByDay);
      setLoading(false);
      if (createClassAttenceByDay?.is_success === true) {
        setAlert(true, "success", createClassAttenceByDay?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createClassAttenceByDay?.message);
        // console.log("first", createClassAttenceByDay?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      // console.log("error", error);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    classId: Yup.string(),
    attendanceDate: Yup.string().required(t("require")),
  });

  const formik = useFormik({
    initialValues: {
      classId: "",
      attendanceDate: moment(),
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("values:::", values, classId);
      setLoading(true);
      createClassAttenceByDay({
        variables: {
          classId: classId,
          attendanceDate: moment(values?.attendanceDate).format("YYYY-MM-DD"),
        },
      });
    },
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    resetForm,
    setFieldValue,
  } = formik;

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography
              className={language === "en" ? "dialog-title" : "dialog-title-kh"}
            >
              {t("dialog_title_generate_attendance")}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("date")}
                </Typography>
                <DatePickerForDialog
                  date={values?.attendanceDate}
                  setDate={(e) => setFieldValue("attendanceDate", e)}
                />
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
      <DialogActions>
        <Grid size={{ xs: 12 }} className="create-container">
          {loading ? (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
            >
              {t("loading")}
            </Button>
          ) : (
            <Button
              className={language === "kh" ? "btn-create-kh" : "btn-create"}
              fullWidth
              onClick={handleSubmit}
            >
              {t("btn-create")}
            </Button>
          )}
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
